// a list of tokens by chain
import { Currency, Token } from '@uniswap/sdk-core'

import { SupportedChainId } from './chains'
import {
  ANI,
  CKToken_TESTNET,
  DAI,
  DAI_TESTNET,
  ETH,
  HYUSD,
  LYDRA,
  LYDRA_DEV,
  LYDRA_TESTNET,
  MYTOKEN1_DEV,
  MYTOKEN1_TESTNET,
  MYTOKEN2_DEV,
  MYTOKEN2_TESTNET,
  nativeOnChain,
  USDC,
  USDT,
  WBTC,
  WRAPPED_NATIVE_CURRENCY,
} from './tokens'

type ChainTokenList = {
  readonly [chainId: number]: Token[]
}

type ChainCurrencyList = {
  readonly [chainId: number]: Currency[]
}

const WRAPPED_NATIVE_CURRENCIES_ONLY: ChainTokenList = Object.fromEntries(
  Object.entries(WRAPPED_NATIVE_CURRENCY)
    .map(([key, value]) => [key, [value]])
    .filter(Boolean)
)

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
  [SupportedChainId.HYDRA]: [
    ...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.HYDRA],
    ETH,
    WBTC,
    DAI,
    USDC,
    USDT,
    HYUSD,
  ],
  [SupportedChainId.TESTNET]: [...WRAPPED_NATIVE_CURRENCIES_ONLY[SupportedChainId.TESTNET], DAI_TESTNET],
}
export const ADDITIONAL_BASES: {
  [chainId: number]: { [tokenAddress: string]: Token[] }
} = {}
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: {
  [chainId: number]: { [tokenAddress: string]: Token[] }
} = {}

/**
 * Shows up in the currency select for swap and add liquidity
 */
export const COMMON_BASES: ChainCurrencyList = {
  [SupportedChainId.HYDRA]: [
    nativeOnChain(SupportedChainId.HYDRA),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.HYDRA] as Token,
    LYDRA,
    HYUSD,
    ANI,
  ],
  [SupportedChainId.TESTNET]: [
    nativeOnChain(SupportedChainId.TESTNET),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.TESTNET] as Token,
    LYDRA_TESTNET,
    MYTOKEN1_TESTNET,
    MYTOKEN2_TESTNET,
    CKToken_TESTNET,
  ],
  [SupportedChainId.DEVNET]: [
    nativeOnChain(SupportedChainId.DEVNET),
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.DEVNET] as Token,
    LYDRA_DEV,
    MYTOKEN1_DEV,
    MYTOKEN2_DEV,
  ],
}
